import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export function HowItWorks() {
  const { t } = useLang();
  const steps = t("how.steps");
  const nums = ["01", "02", "03", "04", "05"];

  return (
    <section id="how" data-testid="how-section" className="relative z-10 bg-[#0a0a0a] py-24 md:py-36 border-y border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-16 md:mb-24">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("how.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.02]">
            {t("how.heading")}
          </h2>
        </Reveal>

        <div className="divide-y divide-white/8">
          {steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div data-testid={`how-step-${nums[i]}`} className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-11 items-baseline hover:bg-white/[0.02] transition-colors duration-300 -mx-4 px-4 rounded-xl">
                <div className="md:col-span-3">
                  <span className="font-display font-black text-6xl md:text-7xl lg:text-8xl text-white/10 group-hover:text-white/25 transition-colors duration-500 leading-none">
                    {nums[i]}
                  </span>
                </div>
                <h3 className="md:col-span-4 font-display text-2xl md:text-3xl font-semibold text-white">{s.title}</h3>
                <p className="md:col-span-5 text-zinc-400 leading-relaxed md:text-lg">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
